var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 17.493,
    viewBox: "0 0 19 17.493",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1270",
    "data-name": "Rectangle 1270",
    width: 18,
    height: 16.493,
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1270-2",
    "data-name": "Rectangle 1270",
    width: 18,
    height: 16.493,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "comment_icon",
    "data-name": "comment icon",
    transform: "translate(-1121 -684.754)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1469",
    "data-name": "Group 1469",
    transform: "translate(1122 685.754)",
    opacity: 0.37
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1467",
    "data-name": "Group 1467",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25717",
    "data-name": "Path 25717",
    d: "M15.528.625H2.242A1.616,1.616,0,0,0,.625,2.242V10.27a1.617,1.617,0,0,0,1.617,1.617h4.4L6.29,15.638l5.24-3.751h4a1.618,1.618,0,0,0,1.617-1.617V2.242A1.617,1.617,0,0,0,15.528.625Z",
    transform: "translate(0.115 0.115)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1468",
    "data-name": "Group 1468",
    transform: "translate(1121 684.754)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1467-2",
    "data-name": "Group 1467",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25717-2",
    "data-name": "Path 25717",
    d: "M15.528.625H2.242A1.616,1.616,0,0,0,.625,2.242V10.27a1.617,1.617,0,0,0,1.617,1.617h4.4L6.29,15.638l5.24-3.751h4a1.618,1.618,0,0,0,1.617-1.617V2.242A1.617,1.617,0,0,0,15.528.625Z",
    transform: "translate(0.115 0.115)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIconNew);
export default __webpack_public_path__ + "static/media/comment-icon-new.2f3b5b380939530c9e6830413b156828.svg";
export { ForwardRef as ReactComponent };